"use client";

import { c as _c } from "react/compiler-runtime";
import { useEffect, useRef, useState } from "react";
import { useHits, useInstantSearch } from "react-instantsearch";
function buildMessage(count: number): string {
  if (count === 0) return "No products match your filters";
  if (count === 1) return "Showing 1 product";
  return `Showing ${count} products`;
}
export function PlpResultAnnouncer() {
  const $ = _c(6);
  const {
    status
  } = useInstantSearch();
  const {
    results
  } = useHits();
  const count = results?.nbHits ?? 0;
  const [message, setMessage] = useState("");
  const lastAnnouncedCount = useRef(null);
  let t0;
  let t1;
  if ($[0] !== count || $[1] !== status) {
    t0 = () => {
      if (status === "loading" || status === "stalled") {
        return;
      }
      if (lastAnnouncedCount.current === count) {
        return;
      }
      lastAnnouncedCount.current = count;
      setMessage(buildMessage(count));
    };
    t1 = [status, count];
    $[0] = count;
    $[1] = status;
    $[2] = t0;
    $[3] = t1;
  } else {
    t0 = $[2];
    t1 = $[3];
  }
  useEffect(t0, t1);
  let t2;
  if ($[4] !== message) {
    t2 = <div className="sr-only" aria-live="polite" aria-atomic="true" data-testid="plp-result-announcer">{message}</div>;
    $[4] = message;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  return t2;
}